import "./TrialMessage.css";
import images from "../../../../utilities/images/images";
import { useHistory } from "react-router-dom";

const TrialMessageModal = ({ isOpen, onClose, freeBenefits }) => {
  const history = useHistory();

  if (!isOpen) return null;

  const trialMessage = freeBenefits;

  return (
    trialMessage && (
      <div className="app-container">
        <div className="card_newuser_trialmessage">
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>

          <div className="header-trial">
            <div className="icon-circle">
              <img
                src={images.trialMessageicon}
                alt="Trial Message Icon"
                className="trial-icon"
              />
            </div>
          </div>

          <div style={{ marginTop: "36px" }}>
            <p className="title-newuser">{trialMessage}</p>
          </div>

          <div style={{ marginTop: "20px" }}>
            <button
              className="upgrade-btn-message"
              onClick={() => history.push("/store")}
            >
              Upgrade for Full Access
            </button>

            <p className="discount-text">
              <span className="discount-icon">
                <img
                  src={images.new_report}
                  style={{ width: "18px", height: "18px" }}
                  alt="new_report"
                />
              </span>{" "}
              Discount automatically applied during the checkout.
            </p>
          </div>
        </div>
      </div>
    )
  );
};

export default TrialMessageModal;
